import { render, staticRenderFns } from "./DetailApprovalKasKeluar.vue?vue&type=template&id=d5457d90&"
import script from "./DetailApprovalKasKeluar.vue?vue&type=script&lang=js&"
export * from "./DetailApprovalKasKeluar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports